import React, { useState } from "react";
import "./../../../assets/css/student/StudentPayments.css";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";

// ─── MOCK DATA ─────────────────────────────────────────────────────────────────

// Only completed/paid payments — student already enrolled & paid
const PAYMENTS_DATA = [
  {
    id: 1,
    mentor: "Dr. Sarah Mitchell",
    initials: "SM",
    course: "Advanced Machine Learning",
    amount: 41500,
    status: "paid",
    date: "Apr 10, 2025",
    invoiceId: "#INV-2025-0041",
  },
  {
    id: 2,
    mentor: "James Thornton",
    initials: "JT",
    course: "Full Stack Engineering Mastery",
    amount: 22000,
    status: "paid",
    date: "Mar 28, 2025",
    invoiceId: "#INV-2025-0038",
  },
  {
    id: 3,
    mentor: "Priya Nair",
    initials: "PN",
    course: "System Design Fundamentals",
    amount: 55500,
    status: "paid",
    date: "Mar 15, 2025",
    invoiceId: "#INV-2025-0033",
  },
  {
    id: 4,
    mentor: "Nina Okafor",
    initials: "NO",
    course: "Data Science Bootcamp",
    amount: 63800,
    status: "paid",
    date: "Feb 20, 2025",
    invoiceId: "#INV-2025-0025",
  },
  {
    id: 5,
    mentor: "Leo Vasquez",
    initials: "LV",
    course: "UI/UX Design Sprint",
    amount: 16400,
    status: "paid",
    date: "Feb 10, 2025",
    invoiceId: "#INV-2025-0019",
  },
];

// Only mentors whose courses the student has PAID & enrolled in
const MENTOR_DATA = [
  {
    id: 1,
    name: "Dr. Sarah Mitchell",
    initials: "SM",
    specialty: "AI & Machine Learning",
    course: "Advanced Machine Learning",
    paidOn: "Apr 10, 2025",
    amount: 41500,
    sessions: 24,
    rating: 4.9,
  },
  {
    id: 2,
    name: "James Thornton",
    initials: "JT",
    specialty: "Full Stack Development",
    course: "Full Stack Engineering Mastery",
    paidOn: "Mar 28, 2025",
    amount: 22000,
    sessions: 18,
    rating: 4.7,
  },
  {
    id: 3,
    name: "Priya Nair",
    initials: "PN",
    specialty: "System Architecture",
    course: "System Design Fundamentals",
    paidOn: "Mar 15, 2025",
    amount: 55500,
    sessions: 32,
    rating: 5.0,
  },
  {
    id: 4,
    name: "Nina Okafor",
    initials: "NO",
    specialty: "Data Science & Analytics",
    course: "Data Science Bootcamp",
    paidOn: "Feb 20, 2025",
    amount: 63800,
    sessions: 40,
    rating: 4.8,
  },
  {
    id: 5,
    name: "Leo Vasquez",
    initials: "LV",
    specialty: "Product & UX Design",
    course: "UI/UX Design Sprint",
    paidOn: "Feb 10, 2025",
    amount: 16400,
    sessions: 12,
    rating: 4.6,
  },
];

const INVOICE_DATA = [
  {
    id: "#INV-2025-0041",
    mentor: "Dr. Sarah Mitchell",
    course: "Advanced Machine Learning",
    amount: 41500,
    date: "Apr 10, 2025",
    status: "paid",
  },
  {
    id: "#INV-2025-0038",
    mentor: "James Thornton",
    course: "Full Stack Engineering Mastery",
    amount: 22000,
    date: "Mar 28, 2025",
    status: "paid",
  },
  {
    id: "#INV-2025-0033",
    mentor: "Priya Nair",
    course: "System Design Fundamentals",
    amount: 55500,
    date: "Mar 15, 2025",
    status: "paid",
  },
  {
    id: "#INV-2025-0025",
    mentor: "Nina Okafor",
    course: "Data Science Bootcamp",
    amount: 63800,
    date: "Feb 20, 2025",
    status: "paid",
  },
  {
    id: "#INV-2025-0019",
    mentor: "Leo Vasquez",
    course: "UI/UX Design Sprint",
    amount: 16400,
    date: "Feb 10, 2025",
    status: "paid",
  },
];

// ─── HELPERS ───────────────────────────────────────────────────────────────────

const fmt = (n) => "Rs. " + n.toLocaleString("en-PK");

const StarRating = ({ rating }) => (
  <span className="sp-stars">
    {"★".repeat(Math.floor(rating))}
    {rating % 1 ? "½" : ""}
    <span className="sp-rating-num">{rating}</span>
  </span>
);

// ─── SVG ICONS ─────────────────────────────────────────────────────────────────

const IconDownload = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 3v13M7 11l5 5 5-5M3 19h18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconReceipt = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 2h16v20l-3-2-2 2-2-2-2 2-2-2-3 2V2z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8h8M8 12h6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
const IconShield = ({ size = 13, color = "#16A34A" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L4 6v6c0 5.5 3.5 10.7 8 12 4.5-1.3 8-6.5 8-12V6L12 2z"
      stroke={color}
      strokeWidth="1.8"
      fill={color}
      fillOpacity="0.12"
    />
    <path
      d="M9 12l2 2 4-4"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconMyPay = ({ color = "currentColor" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <rect
      x="2"
      y="5"
      width="20"
      height="14"
      rx="2"
      stroke={color}
      strokeWidth="1.8"
    />
    <path
      d="M2 10h20M6 14h4"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconMentor = ({ color = "currentColor" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="1.8" />
    <path
      d="M3 21v-1a6 6 0 016-6h0"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M17 13l2 2 4-4"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const IconHistory = ({ color = "currentColor" }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 12a9 9 0 109-9H3"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M3 7v5h5"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 7v5l3 2"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconTrend = ({ dir = "up" }) => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
    <path
      d={
        dir === "up"
          ? "M7 17L17 7M17 7H10M17 7v7"
          : "M7 7l10 10M17 17H10M17 17v-7"
      }
      stroke={dir === "up" ? "#16A34A" : "#DC2626"}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ─── KPI CARD ──────────────────────────────────────────────────────────────────

const KpiCard = ({ label, value, variant, icon, change, changeDir }) => (
  <div className={`sp-kpi sp-kpi-${variant}`}>
    <div className="sp-kpi-icon">{icon}</div>
    <div className="sp-kpi-body">
      <div className="sp-kpi-label">{label}</div>
      <div className="sp-kpi-value">{value}</div>
      {change && (
        <div className={`sp-kpi-change sp-kpi-change--${changeDir}`}>
          <IconTrend dir={changeDir} />
          {change}
        </div>
      )}
    </div>
  </div>
);

// ─── MY PAYMENTS TAB ───────────────────────────────────────────────────────────

const MyPaymentsTab = () => (
  <div className="sp-tab-content">
    <div className="sp-section-header">
      <span className="sp-section-title">Recent Payments</span>
      <span className="sp-section-count">
        {PAYMENTS_DATA.length} transactions
      </span>
    </div>

    <div className="sp-payment-list">
      {PAYMENTS_DATA.map((p) => (
        <div className="sp-payment-card" key={p.id}>
          <div className="sp-payment-avatar">{p.initials}</div>

          <div className="sp-payment-info">
            <div className="sp-payment-name">{p.mentor}</div>
            <div className="sp-payment-course">{p.course}</div>
          </div>

          <div className="sp-payment-center">
            <span className="sp-badge sp-badge--paid">
              <span className="sp-dot" />
              Paid
            </span>
            <div className="sp-payment-date">{p.date}</div>
          </div>

          <div className="sp-payment-amount">{fmt(p.amount)}</div>

          <div className="sp-payment-actions">
            <button className="sp-btn sp-btn--outline sp-btn--sm">
              <IconReceipt /> Receipt
            </button>
            <button
              className="sp-btn sp-btn--ghost sp-btn--sm"
              title="Download"
            >
              <IconDownload />
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ─── MENTOR PAYMENTS TAB ───────────────────────────────────────────────────────

const MentorPaymentsTab = () => (
  <div className="sp-tab-content">
    <div className="sp-section-header">
      <span className="sp-section-title">Enrolled Mentors</span>
      <span className="sp-section-count">{MENTOR_DATA.length} mentors</span>
    </div>

    <div className="sp-mentor-grid">
      {MENTOR_DATA.map((m) => (
        <div className="sp-mentor-card" key={m.id}>
          <div className="sp-mentor-header">
            <div className="sp-mentor-avatar">{m.initials}</div>
            <div className="sp-mentor-meta">
              <div className="sp-mentor-name">{m.name}</div>
              <div className="sp-mentor-specialty">{m.specialty}</div>
              <StarRating rating={m.rating} />
            </div>
            <span className="sp-badge sp-badge--paid">
              <span className="sp-dot" />
              Enrolled
            </span>
          </div>

          <div className="sp-mentor-course-tag">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                stroke="#7A1C1C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            {m.course}
          </div>

          <div className="sp-mentor-stats">
            <div className="sp-mstat">
              <div className="sp-mstat-val">{fmt(m.amount)}</div>
              <div className="sp-mstat-lbl">Course Fee Paid</div>
            </div>
            <div className="sp-mstat-div" />
            <div className="sp-mstat">
              <div className="sp-mstat-val">{m.sessions}</div>
              <div className="sp-mstat-lbl">Sessions Total</div>
            </div>
            <div className="sp-mstat-div" />
            <div className="sp-mstat">
              <div className="sp-mstat-val">{m.paidOn}</div>
              <div className="sp-mstat-lbl">Enrolled On</div>
            </div>
          </div>

          <div className="sp-mentor-footer">
            <button className="sp-btn sp-btn--outline sp-btn--sm">
              <IconReceipt /> Receipt
            </button>
            <button className="sp-btn sp-btn--ghost sp-btn--sm">
              <IconDownload /> Invoice
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

// ─── TRANSACTION HISTORY TAB ───────────────────────────────────────────────────

const TransactionHistoryTab = () => (
  <div className="sp-tab-content">
    <div className="sp-section-header">
      <span className="sp-section-title">Transaction History</span>
      <button className="sp-export-btn">
        <IconDownload /> Export CSV
      </button>
    </div>

    <div className="sp-table-wrap">
      <table className="sp-table">
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Mentor</th>
            <th>Course</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {INVOICE_DATA.map((inv, i) => (
            <tr key={i}>
              <td>
                <span className="sp-invoice-id">{inv.id}</span>
              </td>
              <td className="sp-table-mentor">{inv.mentor}</td>
              <td className="sp-table-course">{inv.course}</td>
              <td>
                <span className="sp-table-amount">{fmt(inv.amount)}</span>
              </td>
              <td className="sp-table-date">{inv.date}</td>
              <td>
                <span className="sp-badge sp-badge--paid">
                  <span className="sp-dot" />
                  Paid
                </span>
              </td>
              <td>
                <div className="sp-table-actions">
                  <button className="sp-btn sp-btn--outline sp-btn--sm">
                    <IconReceipt /> Receipt
                  </button>
                  <button className="sp-btn sp-btn--ghost sp-btn--sm">
                    <IconDownload />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

// ─── TABS CONFIG ───────────────────────────────────────────────────────────────

const TABS = [
  { id: "my", label: "My Payments", icon: <IconMyPay /> },
  { id: "mentor", label: "Mentor Payments", icon: <IconMentor /> },
  { id: "history", label: "Transaction History", icon: <IconHistory /> },
];

// ─── PAGE ROOT ─────────────────────────────────────────────────────────────────

export default function PaymentsPage() {
  const [tab, setTab] = useState("my");

  const totalSpent = PAYMENTS_DATA.reduce((s, p) => s + p.amount, 0);

  return (
    <MyStudentLayout>
      <div className="sp-root">
        {/* ── HEADER ── */}
        <div className="sp-header">
          <div className="sp-header-left">
            <h1 className="sp-title">Payments &amp; Billing</h1>
            <p className="sp-subtitle">
              View your payment history, enrolled mentor fees, and download
              receipts
            </p>
          </div>
          <div className="sp-trust-badges">
            <div className="sp-trust">
              <IconShield /> Secure Gateway
            </div>
            <div className="sp-trust">
              <IconShield /> 256-bit Encrypted
            </div>
            <div className="sp-trust">
              <IconShield /> Verified Payments
            </div>
          </div>
        </div>

        {/* ── KPI CARDS ── */}
        <div className="sp-kpi-grid">
          <KpiCard
            label="Total Spent"
            value={fmt(totalSpent)}
            variant="spent"
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M2 8h20M2 8v10a2 2 0 002 2h16a2 2 0 002-2V8M2 8l2-4h16l2 4"
                  stroke="#7A1C1C"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <circle cx="12" cy="14" r="2" fill="#7A1C1C" opacity="0.5" />
              </svg>
            }
            change="Across all courses"
            changeDir="up"
          />
          <KpiCard
            label="Courses Enrolled"
            value={PAYMENTS_DATA.length}
            variant="courses"
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                  stroke="#7C3AED"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            change="All active"
            changeDir="up"
          />
          <KpiCard
            label="Mentors Engaged"
            value={MENTOR_DATA.length}
            variant="mentors"
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="9"
                  cy="7"
                  r="4"
                  stroke="#2563EB"
                  strokeWidth="1.8"
                />
                <path
                  d="M3 21v-1a6 6 0 016-6"
                  stroke="#2563EB"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
                <path
                  d="M17 13l2 2 4-4"
                  stroke="#2563EB"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            change="Expert instructors"
            changeDir="up"
          />
          <KpiCard
            label="Last Payment"
            value={fmt(PAYMENTS_DATA[0].amount)}
            variant="last"
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="9"
                  stroke="#D97706"
                  strokeWidth="1.8"
                />
                <path
                  d="M12 7v5l3 3"
                  stroke="#D97706"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
            change={PAYMENTS_DATA[0].date}
            changeDir="up"
          />
        </div>

        {/* ── TAB BAR ── */}
        <div className="sp-tab-bar">
          {TABS.map((t) => (
            <button
              key={t.id}
              className={`sp-tab-btn ${tab === t.id ? "sp-tab-btn--active" : ""}`}
              onClick={() => setTab(t.id)}
            >
              {t.icon}
              {t.label}
            </button>
          ))}
        </div>

        {/* ── CONTENT ── */}
        {tab === "my" && <MyPaymentsTab />}
        {tab === "mentor" && <MentorPaymentsTab />}
        {tab === "history" && <TransactionHistoryTab />}
      </div>
    </MyStudentLayout>
  );
}
